import React from 'react';
import { useTheme } from 'styled-components';

import { Barra, ItemRanking, Ranking, Trilho } from './styles';
import { Formato, ItemValor } from '../../types/Dashboard';
import { formatarValor } from '../../utils/formatadores';

// Ranking (categoria, vendedor, conta): rótulo e valor em texto, barra fina abaixo.
// Com valores negativos o zero vai para o meio e a barra negativa cresce para a esquerda.
export default function BarrasHorizontais({ itens, formato }: { itens: ItemValor[]; formato: Formato }) {
  const theme = useTheme();
  const maxAbs = Math.max(...itens.map(i => Math.abs(i.valor)), 0);
  const temNegativo = itens.some(i => i.valor < 0);
  if (maxAbs === 0) return null;

  return (
    <Ranking>
      {itens.map((item, i) => {
        const negativo = item.valor < 0;
        const barra = (
          <Barra
            $largura={Math.abs(item.valor) / maxAbs}
            $cor={negativo ? theme.cores.poloNegativo : theme.cores.serie[0]}
            title={`${item.rotulo}: ${formatarValor(item.valor, formato)}`}
          />
        );

        return (
          <ItemRanking key={`${item.rotulo}${i}`}>
            <div className='linha'>
              <span className='rotulo' title={item.rotulo}>{item.rotulo}</span>
              <span className={`valor${negativo ? ' negativo' : ''}`}>{formatarValor(item.valor, formato)}</span>
            </div>
            {temNegativo ? (
              <Trilho $comNegativo>
                <div className='metade esquerda'>{negativo && barra}</div>
                <div className='zero' />
                <div className='metade'>{!negativo && barra}</div>
              </Trilho>
            ) : (
              <Trilho $comNegativo={false}>{barra}</Trilho>
            )}
          </ItemRanking>
        );
      })}
    </Ranking>
  );
}
